import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Camera, CheckCircle, Loader2 } from 'lucide-react';
import CorporateHeader from './CorporateHeader';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const AIFlyersThankYouPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id') || '';
  const packageId = searchParams.get('package') || '';
  const [confirming, setConfirming] = useState(true);
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (!sessionId) { setConfirming(false); return; }
    const confirmPayment = async () => {
      try {
        const res = await fetch(`${API_URL}/api/ai-service/confirm-payment`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId, origin_url: window.location.origin }),
        });
        const data = await res.json();
        setConfirmed(data.confirmed === true);
      } catch (err) {
        console.error(err);
      } finally {
        setConfirming(false);
      }
    };
    confirmPayment();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-black">
      <CorporateHeader />
      <div className="pt-28 pb-20">
        <div className="container mx-auto px-4 max-w-2xl text-center">
          <div className="bg-gray-900/50 border border-amber-800/30 rounded-2xl p-8 sm:p-12">
            {confirming ? (
              <div className="py-8">
                <Loader2 className="w-12 h-12 text-amber-400 mx-auto mb-4 animate-spin" />
                <p className="text-gray-400">Confirming your payment...</p>
              </div>
            ) : (
              <>
                <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-6" />
                <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-testid="flyer-thankyou-title">
                  Payment Confirmed. Your transformation starts now.
                </h1>
                <p className="text-gray-400 leading-relaxed mb-8">
                  To begin your flyer design, please complete your intake form and upload your photos.
                </p>
                <Button
                  onClick={() => navigate(`/flyer-intake?session_id=${sessionId}&package=${packageId}`)}
                  className="bg-gradient-to-r from-amber-600 to-yellow-600 hover:from-amber-700 hover:to-yellow-700 text-black font-bold px-8 py-4 text-lg rounded-full"
                  data-testid="flyer-complete-intake-btn"
                >
                  <Camera className="w-5 h-5 mr-2" />
                  Complete Your Intake
                </Button>
              </>
            )}
          </div>
          <div className="mt-8">
            <p className="text-amber-400/80 text-sm font-semibold tracking-wider">eBlackBook AI Luxury Flyer Design</p>
            <p className="text-gray-600 text-xs mt-1">Powered by eBlackBookListings</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIFlyersThankYouPage;
